import { connect } from 'react-redux';
import Events from './Events';
import I18n from '../../lib/i18n';
import { isLoadingSelector } from '../../modules/LoadingStatus';
import { timelineSelector, fetchTimeline } from '../../modules/Timeline';

const mapStateToProps = state => ({
  events: timelineSelector(state),
  isRefreshing: isLoadingSelector(state, 'fetchTimeline'),
  emptyText: I18n.t('Dashboard.Timeline.emptyText'),
});

const mapDispatchToProps = {
  fetchEvents: fetchTimeline,
};

export default connect(mapStateToProps, mapDispatchToProps)(Events);
